import {connect} from "react-redux";
import * as CoursesActions from '../../store/actions/coursesActions';
import CourseAdmin from '../../components/AdminPanel/CourseAdmin';
import * as VideoActions from '../../store/actions/videoActions';

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.courses
});

const mapDispatchToProps = (dispatch) => ({
    onLoadCourses: (uid, courseUsers, token) => {
        dispatch(CoursesActions.getCoursesForAdmin(uid, courseUsers, token));
    },
    onLoadSubjects: (uid, token) => {
        dispatch(CoursesActions.getSubjectsForAdmin(uid, token));
    },
    getSingleCourse: (courseId, token) => {
        dispatch(CoursesActions.getSingleCourse(courseId, token));
    },
    getSingleSubject: (subjectId, token) => {
        dispatch(CoursesActions.getSingleSubject(subjectId, token));
    },
    setActiveCourse: (course, profileId, token) => {
        dispatch(CoursesActions.setActiveCourse(course));
        dispatch(VideoActions.getSingleCourseUser(profileId, course.id, token));
    },
    removeCourseConfirmation: (id, token) => {
      dispatch(CoursesActions.deleteCourse(id, token));
    },
    removeSubjectConfirmation: (id, token) => {
        dispatch(CoursesActions.deleteSubject(id, token));
    },
    removeChapterConfirmation: (id, token) => {
        dispatch(CoursesActions.removeChapterPart(id, token));
    },
    hideModalDelete: () => {
        dispatch(CoursesActions.hideModalDeletePart());
    },
    editChapterInfo: (chapter, courseId, subjectId, files, uid, cu, token) => {
        dispatch(CoursesActions.editChapterInformation(chapter, courseId, subjectId, files, uid, cu, token));
    },
    addNewChapter: (chapter, courseId, subjectId, files, uid, cu, token) => {
        dispatch(CoursesActions.addChapter(chapter, courseId, subjectId, files, uid, cu, token));
    },
    deleteOneChapter: (id, token) => {
        dispatch(CoursesActions.deleteChapter(id, token));
    },
    addNewSubject: (subject, courseId, userId, token, socket, profileId) => {
        dispatch(CoursesActions.addNewSubject(subject, courseId, userId, token, socket, profileId));
    },
    addNewCourse: (course, token) => {
        dispatch(CoursesActions.addNewCourse(course, token));
    },
    reorderChapterParts: (data, token) => {
        dispatch(CoursesActions.reorderChapterParts(data, token));
    },
    reorderChapters: (data, token) => {
        dispatch(CoursesActions.reorderChapters(data, token));
    },
    deleteChapterFile: (id, token) => {
        dispatch(CoursesActions.deleteChapterFile(id, token));
    },
    updateChapterStatus: (id, status, token) => {
        dispatch(CoursesActions.updateChapterStatus(id, status, token));
    },
    updateChapterPartStatus: (id, status, token) => {
        dispatch(CoursesActions.updateChapterPartStatus(id, status, token));
    },
    fakeUpdateSubject: (subject) => {
        dispatch(CoursesActions.fakeUpdateSubject(subject));
    },
    updateSubject: (subject, token) => {
        dispatch(CoursesActions.updateSubject(subject, token));
    },
    saveTest: (test, token) => {
        dispatch(CoursesActions.updateChapterTest(test, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CourseAdmin);


// WEBPACK FOOTER //
// ./src/containers/AdminPanel/CoursesAdminContainer.js